module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-13 at 03.56.44.b3c945a8.png";